import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 设备属性列表数据
    getDeviceattribute({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/EquipmentProperty/GetAllGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存设备属性
    SaveDeviceproperties({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentProperty/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备属性
    DeleteDeviceproperties({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/EquipmentProperty/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取单位列表数据
    GetAttributetype({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
